import { SigmaEmbedInformation } from "./types";

export const generateEmbedUrl = async (
  embedInformation: SigmaEmbedInformation
) => {
  const embedBody: any = {
    dashboardId: embedInformation.worksheetId,
    passedParameters: {
      email: embedInformation.email,
      ua_client_id: embedInformation.clientId,
      external_user_team: embedInformation.userTeam,
      ua_user_id: embedInformation.userId,
      external_user_id: embedInformation.userId,
      show_footer: embedInformation.showFooter,
      account_type: embedInformation.accountType,
    },
  };
  let returnValue: string | undefined = undefined;
  await fetch(embedInformation.embedGeneratorUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "/",
    },
    body: JSON.stringify(embedBody),
  })
    .then((response) => response.json())
    .then((data) => {
      returnValue = data.embedUrl;
    })
    .catch((error) => {
      console.error(error);
    });

  return returnValue;
};
